import React from "react";
import { inject, observer } from "mobx-react";
import HomePageStore from "../HomePageStore";
import PostcodeModal from "../../../components/Postcode/PostcodeModal";
import { ContentMediaPath } from "../../../utils/ContentMediaPath";
import ImgLazyLoad from "../../ImgLazyLoad";

interface DealerSectionProps {}

interface InjectedProps extends DealerSectionProps {
  homePageStore: HomePageStore;
}

const dealerSection: React.SFC<DealerSectionProps> = (props) => {
  const { homePageStore } = props as InjectedProps;
  const { designatedDealer } = homePageStore;
  const postCodeContent = {
    title: "Your location",
    copy: "Please enter your postcode so we can find your nearest retailer and accurate prices for your area.",
    btnText: "Set Location",
  };

  const showPostcodeOverlayActive = () => {
    const evt = new CustomEvent("selectLocation", { detail: {} });
    window.dispatchEvent(evt);
  };

  return (
    <div className="subaru_find_dealers_wrapper">
      <div className="container">
        <div className="subaru_dealers">
          <div className="subaru_dealer_search">
            <h1>
              Find your nearest <br /> Subaru Retailer
            </h1>
            <p>
              Contact your local dealership to arrange a test <br /> drive and
              inspection of a Subaru.{" "}
            </p>
            <div className="custom_delar_details">
              <div className="custom-addressDetail">
                <div className="customSubPinState">
                  {homePageStore.savedSuburb && (
                    <span className="customSuburb">{`${homePageStore.savedSuburb.name}, ${homePageStore.savedSuburb.postcode} ${homePageStore.savedSuburb.state}`}</span>
                  )}
                </div>
                <a
                  href="#"
                  title="Click here to change the postcode."
                  onClick={(e) => {
                    e.preventDefault();
                    showPostcodeOverlayActive();
                  }}
                >
                  Change
                </a>
              </div>
              <PostcodeModal content={postCodeContent} />
              {designatedDealer && (
                <div className="customFullDetailsSupper">
                  <div className="custom_address1">
                    <div className="customName">{designatedDealer.name}</div>
                    <div className="custom-phone">
                      <div className="customPhoneCallNow">
                        <a
                          href={`tel:${designatedDealer.dealerDetails[0].phone}`}
                        >
                          {designatedDealer.dealerDetails[0].phone}
                        </a>
                      </div>
                    </div>
                    <div className="customAddress">
                      {designatedDealer.dealerDetails[0].address}
                    </div>
                    <div className="customSubPinState">
                      <span className="customSuburb">{`${designatedDealer.dealerDetails[0].suburb}, ${designatedDealer.dealerDetails[0].postCode} ${designatedDealer.state}`}</span>
                    </div>
                  </div>
                  <div className="custom-googleMap-link">
                    {!designatedDealer.isMobileDealer && (
                      <a
                        href={`https://www.google.com/maps/dir/Current+Location/${designatedDealer.name} ${designatedDealer.dealerDetails[0].address} ${designatedDealer.dealerDetails[0].postCode}`}
                      >
                        Get Directions
                      </a>
                    )}
                  </div>
                  <div className="custom-dealer-link">
                    <a
                      href={`/dealers/${designatedDealer.uniqueName}`}
                      className="btn primary dealer-cta"
                    >
                      Contact Retailer
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="subaru_map">
            <div className="subaru_map_image">
              <ImgLazyLoad
                src={`${ContentMediaPath}images/australia-dealers-map.png`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default inject("homePageStore")(observer(dealerSection));
